import { Button, Form, Input, message, Modal, Row, Space } from 'antd'
import { inject, observer } from 'mobx-react'
import React from 'react'

const CreateCompanyDepartmentModal = ({
  visible,
  onCancel,
  companyCode,
  ...otherProps
}) => {
  const { departmentStore } = otherProps
  const [form] = Form.useForm()

  const onSubmit = async formValue => {
    const { name } = formValue
    try {
      await departmentStore.create(name, companyCode)
    } catch (error) {
      message.error(error.vi || 'Có lỗi xảy ra')
      return
    }

    message.success('Tạo phòng ban thành công')
    departmentStore.getAllDepartmentList(companyCode)
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      wrapClassName="custom-modal-wrapper"
      title="Tạo phòng ban"
      visible={visible}
      onOk={form.submit}
      onCancel={onCancel}
      destroyOnClose
      footer={null}>
      <Form form={form} onFinish={onSubmit} layout="vertical">
        <Form.Item
          label="Tên phòng ban"
          name="name"
          rules={[{ required: true, message: 'Vui lòng nhập tên phòng ban!' }]}>
          <Input placeholder={'Tên phòng ban'} />
        </Form.Item>

        <Row justify={'center'} style={{ marginTop: 24 }}>
          <Space>
            <Button onClick={onCancel}>Hủy</Button>
            <Button type={'primary'} htmlType={'submit'}>
              Tạo mới
            </Button>
          </Space>
        </Row>
      </Form>
    </Modal>
  )
}

export default inject('departmentStore')(observer(CreateCompanyDepartmentModal))
